import { stringify } from 'query-string';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { SpacesResponse } from './types.tsx';

export const getCreatePermissionsForSpace = (cloudId: string, spaceKeys: string[]) => {
	const queryString = stringify({
		promotedSpaceKey: spaceKeys,
		promotedSpacesLimit: spaceKeys.length,
		otherSpacesLimit: 0,
	});
	return fetchJson(
		`/gateway/api/ex/confluence/${cloudId}/wiki/rest/create-dialog/1.0/spaces?${queryString}`,
	);
};

export const getLinkedSpaces = (projectKey: string): Promise<SpacesResponse[]> =>
	fetchJson(`/rest/servicedesk/1/servicedesk/${projectKey}/kb`);
